interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  {name: 'stripe', src: 'https://js.stripe.com/v3/'}
];
